<template>
  <article class="introduction">
    <section class="introduction__header">
      <div class="introduction__cont">
        <h3 class="intro__title">{{ intro.title }}</h3>
        <p data-anim="text" v-html="intro.description">{{ intro.description }}</p>
      </div>
    </section>
    <section class="introduction__content" v-if="intro.content.length > 0">
      <div
        class="content__item"
        v-for="content in intro.content"
        :key="content.order"
      >
        <h4 data-anim="title">{{ content.title }}</h4>
        <p
          v-for="text in content.description"
          :key="text"
          v-html="text"
          data-anim="text"
        >
          {{ text }}
        </p>
      </div>
    </section>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import router from '@/router';
import Eventer from 'eventer-js';


export default {
  name: 'Intro',

  data() {
    return {
      intro: {},
    };
  },

  computed: {
    ...mapGetters(['getDataCityComponent']),
  },

  created() {
    this.intro = this.getDataCityComponent(this.$route.params.city, 'intro');

    this.eventer = new Eventer(true);
  },

  mounted() {
    this.links = Array.from(this.$el.querySelectorAll('[data-customlink]'));

    if (this.links.length > 0) {
      this.links.forEach((link) => {
        this.eventer.bindEvent('click', link, this.handleClick);
      });
    }
  },

  methods: {
    handleClick() {
      event.preventDefault();
      const url = event.target.getAttribute('href');

      router.push(url);
    },
  },

  beforeDestroy() {
    if (this.links.length > 0) {
      this.links.forEach((link) => {
        this.eventer.clearAll(link);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.introduction {
  width: 100%;
  padding: 60px 40px;
  box-sizing: border-box;

  color: $color-dark-gray;
  background-color: $color-light;

  @include mq(sm) {
    padding: 100px 100px 120px 100px;
  }
}

.introduction__header,
.introduction__content {
  width: 100%;
}

.introduction__header {
  p {
    margin-top: 25px;
  }
}

.introduction__content {
  display: flex;
  flex-wrap: wrap;

  @include mq(sm) {
    align-items: flex-start;
    justify-content: space-between;
  }
}

.content__item {
  display: inline-block;
  width: 100%;
  margin-top: 60px;

  @include mq(sm) {
    width: calc(50% - 50px);
  }

  h4 {
    font-size: 1rem;
  }

  p {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Intro.vue